import { buildFeedItemsPath, joinFeedApiUrl } from '@feed-widget/api/routes'
import api, { feedClient, FEED_API_URL } from '../client'
import { getStoredCurrentOrg } from '../../lib/currentOrgStorage'

export const feedApi = {
  get: async (params = {}) => {
    const organization =
      params.organization ||
      getStoredCurrentOrg()?.slug

    if (!organization) {
      throw new Error('No organization selected')
    }

    const { organization: _organization, ...feedParams } = params
    const response = await feedClient.get(
      joinFeedApiUrl(FEED_API_URL, buildFeedItemsPath(organization)),
      {
        params: feedParams,
      }
    )
    return response.data
  }
}

export const feedOpsApi = {
  listQueue: async (orgSlug, params = {}) => {
    const response = await api.get(`/${orgSlug}/feed-ops/queue`, { params })
    return response.data
  },
  getPostDetail: async (orgSlug, postId, params = {}) => {
    const response = await api.get(`/${orgSlug}/feed-ops/posts/${postId}`, { params })
    return response.data
  },
  updatePost: async (orgSlug, postId, data) => {
    const response = await api.patch(`/${orgSlug}/feed-ops/posts/${postId}`, data)
    return response.data
  },
  updateRegulationSettings: async (orgSlug, postId, data) => {
    const response = await api.patch(`/${orgSlug}/feed-ops/posts/${postId}/regulation-settings`, data)
    return response.data
  },
  createVariants: async (orgSlug, rootPostId, data) => {
    const response = await api.post(`/${orgSlug}/feed-ops/posts/${rootPostId}/variants`, data)
    return response.data
  },
  resetVariant: async (orgSlug, postId) => {
    const response = await api.delete(`/${orgSlug}/feed-ops/posts/${postId}/variant`)
    return response.data
  },
  // Winning ticket team colors: match colors the card for its one team (or
  // reports that no single team resolves), reset returns it to brand colors.
  matchTicketColors: async (orgSlug, postId) => {
    const response = await api.post(`/${orgSlug}/feed-ops/posts/${postId}/ticket-colors`)
    return response.data
  },
  resetTicketColors: async (orgSlug, postId) => {
    const response = await api.delete(`/${orgSlug}/feed-ops/posts/${postId}/ticket-colors`)
    return response.data
  },
  batchVisibility: async (orgSlug, data) => {
    const response = await api.post(`/${orgSlug}/feed-ops/batch-visibility`, data)
    return response.data
  },
  upsertOrder: async (orgSlug, data) => {
    const response = await api.put(`/${orgSlug}/feed-ops/order`, data)
    return response.data
  },
  upsertOverviewOrder: async (orgSlug, data) => {
    const response = await api.put(`/${orgSlug}/feed-ops/overview-order`, data)
    return response.data
  },
  resetOrder: async (orgSlug, postId, params = {}) => {
    const response = await api.delete(`/${orgSlug}/feed-ops/order/${postId}`, { params })
    return response.data
  },
  resetSurfaceOrder: async (orgSlug, params = {}) => {
    const response = await api.delete(`/${orgSlug}/feed-ops/order`, { params })
    return response.data
  },
}
